import React, { memo } from 'react'

import { Flex, Icon } from 'stardust'
import styled from 'styled-components'

import { CHAT_BUBBLE_WIDTH, RevealElementCSS, SPACERS } from '~/theme'
import { PillFilled } from '~/ui-components/Button'
import colors from '~/ui-components/tokens/colors'

const FlexRow = styled(Flex)<{ textReveal?: boolean }>`
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: ${CHAT_BUBBLE_WIDTH};
  max-width: 80%;
  padding: 0 ${SPACERS.xxs} ${SPACERS.xs};
  gap: ${SPACERS.xs};
  ${(props) => props.textReveal && RevealElementCSS}
`

const ActionPills = ({
  actionPills,
  disabled,
  handleAssistActionPill,
}: {
  actionPills: NonNullable<Playground.AssistantConversationMessage['actionPills']>
  disabled: boolean
  handleAssistActionPill?: (action: Playground.AssistActionPill) => void
}) => (
  <FlexRow textReveal>
    {actionPills.map((pill) => (
      <PillFilled
        key={pill.label}
        trailingIcon={pill.icon ? <Icon name={pill.icon} width={SPACERS.md} color="white" /> : undefined}
        onClick={handleAssistActionPill ? () => handleAssistActionPill(pill) : undefined}
        data-qa={`action-pill-${pill.label}`.toLocaleLowerCase().replace(/\s+/g, '-')}
        height={SPACERS.xxl}
        width="auto"
        px={SPACERS.sm}
        fontSize={SPACERS.sm}
        iconSize={SPACERS.md}
        disabled={disabled}
        aria-disabled={disabled}
        backgroundColor={colors.pulsarPurple16}>
        {pill.label}
      </PillFilled>
    ))}
  </FlexRow>
)

ActionPills.displayName = 'ActionPills'
export default memo(ActionPills)
